import webConfig from '../config/web-config'

export const toTitleCase = (text: string) =>
  text.replace(/\w\S*/g, txt => txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase())

export const capitalise = (text: string) => text.charAt(0).toUpperCase() + text.substr(1)

export const commarizeSimple = function (num: number) {
  const numString = num % 1 ? num.toFixed(2) : num.toString()
  return numString.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
}

export const formatDollars = function (num: any) {
  return '$' + commarizeSimple(num)
}

export const getLinkWithPrefix = (link: string) => {
  if (webConfig.sitePrefix) {
    return `${webConfig.sitePrefix}${link}`
  } else {
    return link
  }
}
